import * as $ from 'jquery'

/**
 * Add Function to jQuery
 * Serialise URL QueryString to {Object}
 * @param url_query_string
 * @returns param {Object}
 * @example
 * URL = http://host.com/?a=1&b=2&c=3
 * var queryObject = $.QueryString;
 * queryObject => {'a':1, 'b':2, 'c':3}
 */
(function($) {
    $.QueryString = (function(a) {
        if (a == "") return {};
        var b = {};
        for (var i = 0; i < a.length; ++i) {
            var p = a[i].split('=', 2);
            if (p.length != 2) continue;
            b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
        }
        return b;
    })(window.location.search.substr(1).split('&'))
})($);

/**
 * Serialise jQuery form to {Object}
 * @param $form
 * @returns param {Object}
 * @example
 * var formObject = serializeObject($('#myform'));
 * formObject => {'a': 1, 'b': 2}
 */
function serializeObject($form) {
    var param = {};
    $.each($form.serializeArray(), function(_, kv) {
        if (param.hasOwnProperty(kv.name)) {
            param[kv.name] = $.makeArray(param[kv.name]);
            param[kv.name].push(kv.value);
        } else {
            param[kv.name] = kv.value;
        }
    });
    return param;
}

/**
 * Overwrites obj1's values with obj2's and adds obj2's if non existent in obj1
 * @param obj1: {Object}
 * @param obj2: {Object}
 * @returns obj3 a new object based on obj1 and obj2  : {Object}
 * @example
 * var objMerge = mergeObject({'a': 1}, {'b': 2});
 * objMerge => {'a': 1, 'b': 2}
 */
function mergeObject(obj1, obj2) {
    var obj3 = {};
    for (var attrname in obj1) {
        obj3[attrname] = obj1[attrname];
    }
    for (var attrname in obj2) {
        obj3[attrname] = obj2[attrname];
    }
    return obj3;
}

export {serializeObject, mergeObject}


// WEBPACK FOOTER //
// ./search/static/search/js/utils/other.js